var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getStorageValue, setStorageValue } from "@madmedical/storage";
import { useBindDeviceMutation, useUnbindDeviceMutation } from "../api";
const STORAGE_KEY = "bleDevices";
const normalize = (_a) => {
    var { boundAt } = _a, device = __rest(_a, ["boundAt"]);
    return (Object.assign({ boundAt: boundAt.toISOString() }, device));
};
const denormalize = (_a) => {
    var { boundAt } = _a, device = __rest(_a, ["boundAt"]);
    return (Object.assign({ boundAt: new Date(boundAt) }, device));
};
/**
 * We persist BLE devices into local storage and backend db as well.
 * Local storage because some needs pairing so we need to be on the same device
 * And backend so we can show connection status on other devices.
 */
export default () => {
    const [bind] = useBindDeviceMutation();
    const [unbind] = useUnbindDeviceMutation();
    const getDevices = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // Only from local to be sure we are on the same device where we paired it - when necessary
        return ((_a = (yield getStorageValue(STORAGE_KEY))) !== null && _a !== void 0 ? _a : []).map(denormalize);
    });
    const getDevice = (type) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const devices = yield getDevices();
        return (_b = devices === null || devices === void 0 ? void 0 : devices.find((device) => device.provider === type)) !== null && _b !== void 0 ? _b : null;
    });
    const addDevice = (device) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const existing = yield getDevice(device.provider);
        if (existing) {
            throw "Can't connect to multiple devices of the same type";
        }
        const boundDevice = yield bind(device).unwrap();
        const devices = (_c = (yield getDevices())) !== null && _c !== void 0 ? _c : [];
        devices.push(denormalize(boundDevice));
        return setStorageValue(STORAGE_KEY, devices.map(normalize));
    });
    const removeDevice = (type) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        const devices = (_d = (yield getDevices())) !== null && _d !== void 0 ? _d : [];
        yield unbind({ provider: type }).unwrap();
        return setStorageValue(STORAGE_KEY, devices.filter((device) => device.provider !== type).map(normalize));
    });
    return { getDevices, addDevice, removeDevice };
};
